<div class="uploader">
  <ng-container *ngIf="file || (inProgress$ | async)">
    <ng-container *ngIf="(inProgress$ | async) !== true">
      <span fxFlex></span>
      <div class="f-name">
        <mat-icon color="success" class="check-circle">check_circle</mat-icon>
        <div class="file-name">
          {{ file.fileName }}
        </div>
      </div>
      <div class="dlt-btn">
        <button
          mat-button
          type="button"
          color="accent"
          [disabled]="isDisabled"
          (click)="deleteFile()"
        >
          <mat-icon>delete</mat-icon>
          {{ deleteLabel || 'Delete' }}
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="inProgress$ | async">
      <!--
          use 2 progress bars here so that the progress starts properly from 0%,
          as it can get a little weird when switching modes
        -->
      <mat-progress-bar
        *ngIf="(uploadPercent$ | async) === null"
        mode="indeterminate"
        color="accent"
      ></mat-progress-bar>
      <mat-progress-bar
        *ngIf="(uploadPercent$ | async) !== null"
        mode="determinate"
        color="accent"
        [value]="uploadPercent$ | async"
      ></mat-progress-bar>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!file && (inProgress$ | async) !== true">
    <span fxFlex></span>
    <mat-error *ngIf="errorMessage">
      {{ errorMessage }}
    </mat-error>
    <button
      mat-stroked-button
      type="button"
      color="accent"
      fxFlexAlign="end"
      [disabled]="isDisabled"
      (click)="fileInput.click()"
    >
      <mat-icon svgIcon="upload"></mat-icon>
      {{ uploadLabel || 'Upload' }}
    </button>
  </ng-container>
</div>

<input
  #fileInput
  hidden="true"
  type="file"
  onclick="this.value=null"
  (change)="fileInputChange($event)"
/>
